'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ReportsDynamicReportCtrl
 * @description
 * # ReportsDynamicReportCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('ReportsDynamicReportCtrl', function ($scope, $filter, api, $location) {
		$scope.reportName = $location.search().report;
		$scope.params = {};
		$scope.loading = true;
		$scope.results = null;
		$scope.sums = null;

		// Initialize sort model for report results
		$scope.sortModelReport = {
			sort: null,
			reverse: false
		};

		const memoized = new Map();

		const memoize = (key, fn) => {
			if (!memoized.has(key)) {
				memoized.set(key, fn());
			}
			return memoized.get(key);
		};

		// Get report definition
		api.dynamicReportGet($scope.reportName).then(report => {
			$scope.report = report;
			$scope.loading = false;

			// Initialize params from URL if available
			const searchParams = $location.search();
			if (report && report.parameters) {
				report.parameters.forEach(param => {
					if (searchParams[param.name] !== undefined) {
						$scope.params[param.name] = searchParams[param.name];
					}
				});
			}
		});

		// Product typeahead - returns promise of all products
		$scope.getProducts = (q) => memoize('products', () => api.getProducts())
			.then(arr => $filter('filter')(arr, q));

		// Product version typeahead
		$scope.getProductVersions = (productId, q) => {
			if (!productId) return Promise.resolve([]);
			return memoize(`versions-${productId}`, () => api.getProductVersions(productId))
				.then(arr => $filter('filter')(arr, q));
		};

		// Variant types typeahead
		$scope.getVariantTypes = (q) => memoize('variantTypes', () => api.adminVariantTypes())
			.then(arr => $filter('filter')(arr, q));

		$scope.runReport = async () => {
			try {
				$scope.loading = true;
				$scope.results = null;

				// Update URL with non-empty parameters
				const searchParams = {report: $scope.reportName};

				// Add all non-empty params to the search object
				Object.keys($scope.params).forEach(key => {
					const value = $scope.params[key];
					if (value !== undefined && value !== null && value !== '') {
						searchParams[key] = value;
					}
				});

				// Update the URL, replacing all search parameters
				$location.search(searchParams);

				// Run the report
				$scope.results = await api.dynamicReportPost($scope.reportName, $scope.params, 'JSON_OBJECT_ARRAY');

				// If results are empty, show a friendly message
				if (!$scope.results || $scope.results.length === 0) {
					toastr.error('No results found for the selected criteria.');
				} else {
					const columnNames = Object.keys($scope.results[0]);
					let sums = {}
					let atLeastOneSum = false;
					columnNames.forEach((colName, i) => {
						let shouldSum = colName.toLowerCase().includes('count') || (colName.startsWith('revenue') && typeof $scope.results[0][colName] === 'number');
						if (shouldSum) {
							sums[colName] = $scope.results.reduce((sum, each) => sum + (each[colName] || 0), 0);
							atLeastOneSum = true;
						}
					});
					$scope.sums = atLeastOneSum ? sums : null;
				}
			} finally {
				$scope.loading = false;
			}
		};

		// Convert report results to CSV and trigger download
		$scope.downloadCSV = function () {
			if (!$scope.results || !$scope.results.length || !$scope.report || !$scope.report.parameters) {
				return;
			}

			// Get column headers from first result, ignoring Angular internal properties
			const headers = Object.keys($scope.results[0]).filter(key => !key.startsWith('$'));

			// Create CSV content
			let csvContent = headers.map(header => `"${header}"`).join(',') + '\n';
			csvContent += $scope.results.map(row =>
				headers.map(key => {
					const value = row[key];
					return `"${value === null || value === undefined ? '' : String(value).replace(/"/g, '""')}"`;
				}).join(',')
			).join('\n');

			// Process parameters for filename
			const paramString = $scope.report.parameters
				.map(param => ({label: param.label, value: $scope.params[param.name]}))
				.filter(pair => pair.value !== undefined && pair.value !== null && pair.value !== '')
				.map(pair => `${pair.label}=${pair.value}`)
				.join(', ');

			// Use report title for filename
			const reportTitle = $scope.report.title || $scope.reportName;
			const filename = paramString ? `${reportTitle} - ${paramString}.csv` : `${reportTitle}.csv`;

			// Create download link
			const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.setAttribute('href', url);
			link.setAttribute('download', filename);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};
	});
